import { useMemo } from 'react';
import { type Components } from '@tecnobit-srl/components-store';
import { type Route } from '@tecnobit-srl/types';
import { useCoreRouteTypes } from '@tecnobit-srl/route-types-core';
import { useReviewsRouteTypes } from '@tecnobit-srl/reviews-route-types-core';
import { useCoursesRouteTypes } from '@tecnobit-srl/courses-route-types-core';
import { useConsultanciesRouteTypes } from '@tecnobit-srl/consultancies-route-types-core';
import { useVariantRouteTypes } from '@variant';

export const useRouteTypes = (): Components<{
  route: Route;
}> => {
  const core = useCoreRouteTypes();
  const reviews = useReviewsRouteTypes();
  const courses = useCoursesRouteTypes();
  const consultancies = useConsultanciesRouteTypes();
  const variant = useVariantRouteTypes();
  return useMemo(
    () => ({
      ...core,
      ...reviews,
      ...courses,
      ...consultancies,
      ...variant,
    }),
    [core, reviews, courses, consultancies, variant]
  );
};
